<template>
	<div class="row">
		<div class="form-group col-md-3">
			<label>Sedes</label>
			<v-select v-model="campu_id" :options="requirements.campus" :reduce="campu => campu.id" label="name" placeholder="Seleccionar" />
		</div>
		<div class="form-group col-md-3">
			<label>Estado</label>
			<v-select v-model="step_id" :options="requirements.steps" :reduce="step => step.id" label="name" placeholder="Seleccionar" />
		</div>
		<div class="form-group col-md-5">
			<label for="filter_text">Buscar</label>
			<div class="input-group">
				<input v-model="text" @keypress.enter="mtd_executeFilter" class="form-control form-control-sm" id="filter_text" type="text" />
				<button @click="mtd_executeFilter" class="btn btn-xs btn-primary">Filtrar</button>
			</div>
		</div>
	</div>
</template>
<script>
/** Vuex */
import { mapActions, mapGetters } from 'vuex';
export default {
	props: ['prop-execute', 'page'],
	data() {
		return {
			requirements: {
				campus: [],
				steps: [],
			},
			campu_id: null,
			step_id: null,
			text: null,
		};
	},
	created() {
		this.mtd_getRequirements();
		this.mtd_executeFilter();
	},
	computed: {
		...mapGetters(['url_api']),
	},
	watch: {
		propExecute: function (newValue) {
			if (newValue) this.mtd_executeFilter();
		},
		page: function (newValue) {
			if (newValue) this.mtd_executeFilter();
		},
	},
	methods: {
		...mapActions(['get', 'execute_commit']),
		mtd_getRequirements() {
			this.get({ url: `${this.url_api}/requirements/index/filters` })
				.then(res => {
					if (res.state == 'success') {
						this.requirements.campus = res.campus;
						this.requirements.steps = res.steps;
					}
				})
				.catch(err => console.log(err));
		},
		mtd_executeFilter: function (type = null) {
			let pagination = null;
			type == 'new' ? (pagination = 1) : (pagination = this.page);

			this.get({
				url: `${this.url_api}/requirements/index?page=${pagination}&campu_id=${this.campu_id == null ? '' : this.campu_id}&step_id=${
					this.step_id == null ? '' : this.step_id
				}&text=${this.text == null ? '' : this.text}`,
				mutation: 'administrator_requirements/REQUIREMENTS_INDEX__SET_ALL',
			});
		},
	},
};
</script>
